import React, { useState, useEffect } from "react";
import Joyride, { STATUS } from "react-joyride";

const TOUR_KEY = "slotbook_onboarding_complete";

const OnboardingTour = () => {
  const [run, setRun] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth < 768);
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  useEffect(() => {
    const completed = localStorage.getItem(TOUR_KEY);
    if (!completed) {
      const timer = setTimeout(() => setRun(true), 800);
      return () => clearTimeout(timer);
    }
  }, []);

  // ✅ Desktop (sidebar)
  const desktopSteps = [
    {
      target: "[data-tour='nav-staff']",
      title: "👥 Add Your Staff",
      content: "Add staff members and manage their schedules.",
      placement: "right",
      disableBeacon: true,
    },
    {
      target: "[data-tour='nav-services']",
      title: "✂️ Services",
      content: "Create services and set pricing.",
      placement: "right",
    },
    {
      target: "[data-tour='nav-calendar']",
      title: "📅 Calendar",
      content: "Manage bookings and appointments.",
      placement: "right",
    },
    {
      target: "[data-tour='booking-links']",
      title: "🔗 Booking Page",
      content: "Share this link with your customers.",
      placement: "bottom",
    },
  ];

  // ✅ Mobile (Quick Actions)
  const mobileSteps = [
    {
      target: "[data-tour='qa-staff']",
      title: "👥 Add Staff",
      content: "Tap here to add your team.",
      placement: "bottom",
      disableBeacon: true,
    },
    {
      target: "[data-tour='qa-services']",
      title: "✂️ Add Services",
      content: "Create services customers can book.",
      placement: "bottom",
    },
    {
      target: "[data-tour='qa-calendar']",
      title: "📅 View Calendar",
      content: "Check and manage appointments.",
      placement: "bottom",
    },
    {
      target: "[data-tour='booking-links']",
      title: "🔗 Booking Link",
      content: "Share this link with customers.",
      placement: "bottom",
    },
  ];

  const steps = isMobile ? mobileSteps : desktopSteps;

  const tourStyles = {
    options: {
      primaryColor: "#7c3aed",
      backgroundColor: "#fff",
      textColor: "#111827",
      overlayColor: "rgba(0,0,0,0.55)",
      zIndex: 10000,
      width: isMobile ? 280 : 320,
    },
  };

  const handleCallback = (data) => {
    if ([STATUS.FINISHED, STATUS.SKIPPED].includes(data.status)) {
      localStorage.setItem(TOUR_KEY, "true");
      setRun(false);
    }
  };

  if (!run) return null;

  return (
    <Joyride
      steps={steps}
      run={run}
      continuous
      showProgress={false}
      showSkipButton
      scrollToFirstStep
      styles={tourStyles}
      callback={handleCallback}
    />
  );
};

export default OnboardingTour;
